import { useOrganization } from "@/contexts/frontend/organization/useOrganization";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Outlet } from "react-router";

const OrganizationCompareInCharts = () => {
    const organizationContext = useOrganization();

    useDocumentTitle("Comparisons");

    return <Outlet context={organizationContext} />;
};

export default OrganizationCompareInCharts;
